import { render, staticRenderFns } from "./CreditWorkSimulatorResume.vue?vue&type=template&id=39e2bbad&scoped=true&"
import script from "./CreditWorkSimulatorResume.vue?vue&type=script&lang=js&"
export * from "./CreditWorkSimulatorResume.vue?vue&type=script&lang=js&"
import style0 from "./CreditWorkSimulatorResume.vue?vue&type=style&index=0&id=39e2bbad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2bbad",
  null
  
)

export default component.exports